import styled from 'styled-components'
import get from 'lodash/get'
import breakpoint from 'components/breakpoint'
import Link from 'components/Link'

const getSubtitlePortraitDisplay = props => get(props, 'theme.logisterSection.subtitle.display.portrait')
const getSubtitleColor = props => get(props, 'theme.logisterSection.subtitle.color')
const getSubtitleDefaultFontSize = props => get(props, 'theme.logisterSection.subtitle.fontSize.default')
const getSubtitlePortraitFontSize = props => get(props, 'theme.logisterSection.subtitle.fontSize.portrait')
const getSubtitleLineHeight = props => get(props, 'theme.logisterSection.subtitle.lineHeight')
const getSubtitleFontWeight = props => get(props, 'theme.logisterSection.subtitle.fontWeight')
const getSubtitleMargin = props => get(props, 'styles.margin') || get(props, 'theme.logisterSection.subtitle.margin')
const getSubtitleLinkColor = props => get(props, 'theme.logisterSection.subtitle.link.color')
const getSubtitleLinkHoverColor = props =>
  get(props, 'theme.logisterSection.subtitle.hoverColor', get(props, 'theme.link.hoverColor'))

const SubtitleView = styled.div`
  margin: ${getSubtitleMargin};
  font-weight: ${getSubtitleFontWeight};
  font-size: ${getSubtitleDefaultFontSize};
  line-height: ${getSubtitleLineHeight};
  color: ${getSubtitleColor};

  ${breakpoint('portrait')`
    display: ${getSubtitlePortraitDisplay};
    font-size: ${getSubtitlePortraitFontSize};
  `};

  ${Link} {
    white-space: nowrap;
    color: ${getSubtitleLinkColor};

    &:hover {
      color: ${getSubtitleLinkHoverColor};
    }
  }
`

const SubtitleFAQView = styled(SubtitleView)`
  display: inline-block;

  ${breakpoint('portrait')`
    display: ${getSubtitlePortraitDisplay};
  `};
`

export {SubtitleView, SubtitleFAQView}
